import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '../api/authStore'

export const LoggedInGuard = () => {
  const { authToken } = useAuthStore()

  return authToken ? <Outlet /> : <Navigate to="/" />
}
